(function() {
	'use strict';

	angular
		.module('homeMyTasksControllers')
		.controller('MyTasksInitiativeCreationEditController', Controller);

	Controller.$inject = ['$scope', '$state', '$location', 'businessPlanningService'];

	function Controller($scope, $state, $location, businessPlanningService) {
		var ownerDelegateId = $scope.authenticatedUser.ItemPersonID;

		// Get nb tasks        
		businessPlanningService
			.getEditTasks(ownerDelegateId)
			.then(function(toSpecify) {
				$scope.tasksCountByName.initiativeCreationEdit = toSpecify.NbTasks;
			});

		$scope.withTasks = function() {
			return $scope.tasksCountByName.initiativeCreationEdit > 0;
		};

		// Go To Initiative Search
		$scope.goToInitiativeSearchReadyToFillByOwnerDelegate = function () {
		    // TODO: get filters from BE
			var path = $state.href('advancedSearch', {
				sourceType: 'PlanInitiative',
				q: '',
				sf: [
					'99;OwnerDelegateDisplayName_facet:' + ownerDelegateId,
					'99;-CreationStatusValue:ReadyForTracking',
					'99;IsEditableByOwners:true'
				]
			});
            $location.url(path + '#mode=managePSSInitiatives');
		};
	}
})();